import { FC, MouseEvent, PropsWithChildren, useState } from "react";
import { Button, Menu, styled } from "@mui/material";

import { ReactComponent as ProfileIcon } from "assets/icons/profile.svg";

const StyledPicker = styled(Menu)(({ theme }) => ({
    "& .MuiMenu-paper": {
        borderRadius: "10px",
        padding: "14px 10px 24px",
        background: theme.palette.background.secondary,
        maxWidth: "144px",
        width: "100%",
    },
    "& .MuiMenu-list": {
        padding: 0,
    },
}));

export const ProfileButton: FC<PropsWithChildren> = ({ children }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = !!anchorEl;

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

    const handleClose = () => setAnchorEl(null);

    return (
        <>
            <Button
                variant="outlined"
                sx={(theme) => ({
                    padding: 0,
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    minWidth: "44px",
                    fontWeight: 700,
                    color: open ? theme.palette.brandColors.brandGreen : theme.palette.text.secondary,
                    backgroundColor: open ? theme.palette.text.secondary : "none",
                })}
                onClick={handleClick}
            >
                <ProfileIcon />
            </Button>
            <StyledPicker
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                {children}
            </StyledPicker>
        </>
    );
};
